import { DatePicker } from "antd"
import locale from "antd/es/date-picker/locale/ar_EG"
import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { DATE_FORMAT, DATE_TIME_FORMAT } from "../../../constants"
import DateTime from "../../../utils/dateTime"

export default function SimpleDateFilter({
  onSelect,
  value: dateValue,
  valueFormat = DATE_TIME_FORMAT,
  label,
  disabledDate,
  picker,
  ...rest
}) {
  const [value, setValue] = useState()
  const { locale: appLanguage } = useSelector(state => state.app.configs)

  useEffect(() => {
    setValue(!!dateValue ? DateTime.getDateAndTime(dateValue) : null)
  }, [dateValue])
  return (
    <>
      <label className="d-block">{label}</label>
      <DatePicker
        format={picker !== "month" ? DATE_FORMAT : "MMMM-YYYY"}
        picker={picker}
        value={value}
        disabledDate={disabledDate}
        onChange={date => {
          setValue(date)
          onSelect(date, date ? DateTime.formatDate(date, valueFormat) : "")
        }}
        locale={appLanguage === "en" ? [] : locale}
        {...rest}
      />
    </>
  )
}
